// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"65cc441a","216":"1f313989","259":"8988132e","362":"27390c45","416":"caaf60dd","630":"c6b71096","645":"f6e19db9","758":"30267615","766":"0fc14e0d","822":"9f76528d","872":"19a4ad41"}[chunkId] + ".chunk.js";
};